import { brandInfo } from '../../shared/exporters/brandInfo';
import {
  downloadBlob,
  imageToPng,
  loadExcelJS,
  monogramPng,
} from '../../shared/exporters/browser';
import { entryPrintHtml } from '../../shared/exporters/printEntry';
import { openPrintWindow } from '../../shared/exporters/printShared';
import {
  buildEntryWorkbook,
  workbookBlob,
} from '../../shared/exporters/workbooks';
import { entryPrintSections, entrySheetRows } from './entryExport';
import { heroOf } from './entryModel';

// Single-entry downloads from the entry card's Download menu.
// entry: the submission ({ reference, submitted_at, answers, … });
// definition: its version's definition; account: the form's { name, logo }.

// "Driver Registration", "K7QM-4XTR" → "driver-registration-k7qm-4xtr.xlsx"
export const fileSlug = (text, fallback) =>
  String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || fallback;

export const entryFileName = (formName, reference) =>
  `${fileSlug(formName, 'form')}-${fileSlug(reference, 'entry')}.xlsx`;

// Opens the printable page. → 'opened' | 'blocked' (pop-up blocked)
export const printEntry = ({ account, formName, entry, definition }) => {
  const hero = heroOf(definition, entry.answers, entry);
  return openPrintWindow(
    entryPrintHtml({
      brand: brandInfo(account),
      formName,
      entry,
      title: hero.title,
      suffix: hero.suffix,
      sections: entryPrintSections(definition, entry.answers),
    })
  );
};

const DEFAULT_DEPS = {
  loadExcelJS,
  imageToPng,
  monogramPng,
  downloadBlob,
};

// Builds and downloads the entry's .xlsx. Rejects when ExcelJS can't load
// or the file can't be written; a logo that can't be read falls back to the
// monogram (or no image) instead.
export const downloadEntryExcel = async (
  { account, formName, entry, definition },
  deps = DEFAULT_DEPS
) => {
  const ExcelJS = await deps.loadExcelJS();
  const brand = brandInfo(account);
  const [logo, platform] = await Promise.all([
    brand.logo ? deps.imageToPng(brand.logo) : Promise.resolve(null),
    deps.imageToPng(brand.platformLogo),
  ]);
  const wb = buildEntryWorkbook(ExcelJS, {
    brand,
    formName,
    entry,
    rows: entrySheetRows(definition, entry.answers),
    images: { track: logo || deps.monogramPng(brand.mono), platform },
  });
  deps.downloadBlob(
    entryFileName(formName, entry.reference),
    await workbookBlob(wb)
  );
};
